import { commonService } from '.';

const getTrainingParId = (id) => {
    return commonService.getWithParam('Training/trainingById?idTraining=' + id, null);
};

const insertWishTrainingData = (body) => {
    return commonService.post('Training/wishTraining', body);
}

const updateWishTrainingData = (id, body) => {
    return commonService.post('Training/wishTraining?id=' + id, body);
}

const updateTrainingReportData = (id, body) => {
    return commonService.put('Training/trainingReport?id=' + id, body);
}

const updateCertificationAchievedData = (id, file, body) => {
    return commonService.put('Training/certificationAchieved?id=' + id, file, body);
}

const insertTrainingFormations = (id, body) => {
    return commonService.post('Training/insertTraining?id=' + id, body);
}

const deleteTraining = (id, idEa) => {
    return commonService.deleteWithParam('Training/wishTraining?id=' + id + '&idEa=' + idEa);
};

const duplicateTraining = (body) => {
    return commonService.post('Training/duplicate', body);
}

const saveNewTemplate = (body) => {
    return commonService.post('Training/newTemplate', body);
}

const getTrainingTemplate = (id) => {
    return commonService.getWithParam('Training/trainingTemplate?id=' + id, null);
};

const updateManagerOpinionData = (body) => {
    return commonService.put('Training/updateManagerOpinionData', body);
}

export const training = {
    getTrainingParId,
    insertWishTrainingData,
    insertTrainingFormations,
    updateWishTrainingData,
    deleteTraining,
    updateTrainingReportData,
    updateCertificationAchievedData,
    duplicateTraining,
    saveNewTemplate,
    getTrainingTemplate,
    updateManagerOpinionData
};
